import { render, staticRenderFns } from "./BucketItem.vue?vue&type=template&id=2401727f&scoped=true&"
import script from "./BucketItem.ts?vue&type=script&lang=ts&"
export * from "./BucketItem.ts?vue&type=script&lang=ts&"
import style1 from "./BucketItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2401727f",
  null
  
)

export default component.exports